import { createContext } from 'react';

import { noop } from '@tg-web/utils';

export const ProBannerContext = createContext<{
  isProBannerReady: boolean;
  isProTooltipVisible: boolean | null;
  setIsProTooltipVisible: (visible: boolean) => void;
}>({
  isProBannerReady: false,
  isProTooltipVisible: null,
  setIsProTooltipVisible: noop,
});
